<div class="content-wrapper">
  <ng-content />
</div>
